import {
  FETCH_DEFAULT_ASSESSMENTS,
  FETCH_DEFAULT_ASSESSMENTS_SUCCESS,
  FETCH_DEFAULT_ASSESSMENTS_ERROR,
  FETCH_MY_ASSESSMENTS,
  FETCH_MY_ASSESSMENTS_SUCCESS,
  FETCH_MY_ASSESSMENTS_ERROR,
  CREATE_ASSESSMENT,
  CREATE_ASSESSMENT_SUCCESS,
  CREATE_ASSESSMENT_ERROR,
  UPDATE_ASSESSMENT,
  UPDATE_ASSESSMENT_SUCCESS,
  UPDATE_ASSESSMENT_ERROR,
  DELETE_ASSESSMENT,
  DELETE_ASSESSMENT_SUCCESS,
  DELETE_ASSESSMENT_ERROR,
  CLEAR_ASSESSMENT_ERROR,
} from './constants';

// Default (full + basic)
export function fetchDefaultAssessments() {
  return { type: FETCH_DEFAULT_ASSESSMENTS };
}
export function fetchDefaultAssessmentsSuccess(payload) {
  return { type: FETCH_DEFAULT_ASSESSMENTS_SUCCESS, payload };
}
export function fetchDefaultAssessmentsError(error) {
  return { type: FETCH_DEFAULT_ASSESSMENTS_ERROR, error };
}

// My assessments
export function fetchMyAssessments() {
  return { type: FETCH_MY_ASSESSMENTS };
}
export function fetchMyAssessmentsSuccess(list) {
  return { type: FETCH_MY_ASSESSMENTS_SUCCESS, list };
}
export function fetchMyAssessmentsError(error) {
  return { type: FETCH_MY_ASSESSMENTS_ERROR, error };
}

// Create
export function createAssessment(payload) {
  return { type: CREATE_ASSESSMENT, payload };
}
export function createAssessmentSuccess(assessment) {
  return { type: CREATE_ASSESSMENT_SUCCESS, assessment };
}
export function createAssessmentError(error) {
  return { type: CREATE_ASSESSMENT_ERROR, error };
}

// Update
export function updateAssessment(id, payload) {
  return { type: UPDATE_ASSESSMENT, id, payload };
}
export function updateAssessmentSuccess(assessment) {
  return { type: UPDATE_ASSESSMENT_SUCCESS, assessment };
}
export function updateAssessmentError(error) {
  return { type: UPDATE_ASSESSMENT_ERROR, error };
}

// Delete
export function deleteAssessment(id) {
  return { type: DELETE_ASSESSMENT, id };
}
export function deleteAssessmentSuccess(id) {
  return { type: DELETE_ASSESSMENT_SUCCESS, id };
}
export function deleteAssessmentError(error) {
  return { type: DELETE_ASSESSMENT_ERROR, error };
}

export function clearAssessmentError() {
  return { type: CLEAR_ASSESSMENT_ERROR };
}
